module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "max-text-width",
    attrs: {
      "id": "banner"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('affiliateProgram')))]), _vm._v(" "), _c('p', {
    staticClass: "describe max-text-width"
  }, [_vm._v(_vm._s(_vm.$t('memberInfo')))]), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/affiliate/banner_img.png",
      "alt": ""
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-64545d2b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/affiliateProgram/banner/Banner.vue
// module id = 1338
// module chunks = 1